module.exports = __webpack_public_path__ + "img/cr.e1172ee8.svg";